import { App } from "@app/interfaces"
import { useAuth } from "@app/hooks"
import { hasModuleWriteAccess } from "@app/utils"

/**
 * Есть ли у текущего пользователя доступ на запись к модулю staff_schedule.
 * Для OIDC — модульная роль `staff_schedule:w` (регистр важен: роли в Keycloak
 * заведены нижним регистром, как и значение App.ModuleName.STAFF_SCHEDULE).
 * Для STANDARD-авторизации — запись доступна менеджеру/админу.
 */
export const useScheduleWriteAccess = (): boolean => {
  const auth = useAuth()

  if (!auth) {
    return false
  }

  if (auth.type === App.AuthType.OIDC) {
    const userInfo = auth.userInfo as App.OIDCUserInfo | undefined
    const roles = userInfo?.roles ?? []
    return hasModuleWriteAccess(roles, App.ModuleName.STAFF_SCHEDULE)
  }

  return (auth.role ?? App.UserRole.ANON) >= App.UserRole.MANAGER
}
